// @flow
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'
import AppBar from '@material-ui/core/AppBar'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import { withStyles } from '@material-ui/core/styles'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import { colors } from 'catena/er2_styles'
import PropStyles from 'catena/er2_styles/layer_properties'
import type { MapsourcesType } from '../reducers/mapsources'

const toolbarMinHeight = '44px'
const styles = theme => ({
    root: {
        fontFamily: '\'Roboto Condensed\', sans-serif',
        // fontSize: 'smaller',
    },
    box: {
        backgroundColor: 'white',
        width: '200px',
        position: 'absolute',
        zIndex: '200',
        borderRadius: '5px 0px 0px 5px',
        borderLeft: '1px solid #888',
        borderTop: '1px solid #888',
        borderBottom: '1px solid #888',
    },
    closeButton: {
        margin: '10px',
        float: 'right',
    },
    muitoolbarRoot: {
        color: colors.white,
        minHeight: toolbarMinHeight,
        '@media': {
            minHeight: toolbarMinHeight,
        },
    },
    muitypographtTitle: {
        fontSize: '16px',
        fontWeight: 700,
    },
    saveButton: {
        margin: '10px',
    },
})

type PropTypes = {
    baseImageURL: string,
    mapsources: MapsourcesType,
    onClose: Function,
    onSelect: Function,
    pos: {
        right: number,
        top: number,
    },
    theme: PropStyles,
}

type StateTypes = {
    collection: string,
    mongoDatabase: string,
    mongoHost: string,
}

class TimeseriesSourceChooser extends React.Component<PropTypes, StateTypes> {
    constructor(props) {
        super(props)
        this.state = {
            collection: '',
            mongoHost: 'eds0.engr.colostate.edu:27017',
            mongoDatabase: 'csip_timeseries',
        }
    }

    render() {
        return (
            <div
                className={this.props.classes.box}
                style={{
                    right: this.props.pos.right,
                    top: this.props.pos.top,
                    width: '260px',
                }}
            >
                <AppBar
                    color="secondary"
                    position="static"
                >
                    <Tabs value={0}>
                        <Tab classes={{ label: this.props.classes.tabLabel }} label="CSIP Mongodb Source" />
                    </Tabs>
                </AppBar>
                <div>
                    <FormControl fullWidth>
                        <TextField
                            id="mongo_host"
                            defaultValue={this.state.mongoHost}
                            label="MongoDB Host"
                            margin="normal"
                            onChange={(e) => { this.setState({ mongoHost: e.target.value }) }}
                        />
                    </FormControl>
                    <FormControl fullWidth>
                        <TextField
                            id="mongo_database"
                            defaultValue={this.state.mongoDatabase}
                            label="MongoDB Database"
                            margin="normal"
                            onChange={(e) => { this.setState({ mongoDatabase: e.target.value }) }}
                        />
                    </FormControl>
                    <FormControl fullWidth>
                        <TextField
                            id="mongo_collection"
                            defaultValue={this.state.mongoCollection}
                            label="MongoDB Collection"
                            margin="normal"
                            onChange={(e) => { this.setState({ collection: e.target.value }) }}
                        />
                    </FormControl>

                    {this.state.mongoHost && this.state.mongoDatabase && this.state.collection && (
                        <Button
                            classes={{
                                contained: this.props.classes.button,
                            }}
                            className={this.props.classes.saveButton}
                            color="primary"
                            onClick={() => this.props.onSelect({ ...this.state })}
                        >
                            Save
                        </Button>
                    )}
                    <Button
                        classes={{
                            contained: this.props.classes.button,
                        }}
                        className={this.props.classes.closeButton}
                        color="primary"
                        onClick={() => this.props.onClose()}
                    >
                        Close
                    </Button>
                </div>
            </div>
        )
    }
}

export default withStyles(styles)(TimeseriesSourceChooser)
